import { Component, HostBinding } from '@angular/core'
import { Router } from '@angular/router'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { ApplicationArea, AppPractice, GrowthToolkitClient } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'regional-manager-summary',
   templateUrl: './regional-manager-summary-page.component.html',
   styleUrls: ['./regional-manager-summary-page.component.scss'],
   standalone: false,
})
export class GrowthToolkitRegionalManagerSummaryPage {
   @HostBinding('class.full-flex-height') fullFlexHeight = true

   allPractices: any[] = []

   constructor(private authMgr: AuthManager, private router: Router, private growthToolkitClient: GrowthToolkitClient) {
      this.authMgr.getCurrentUser().subscribe((user) => {})
   }

   ngOnInit(): void {
      this.fetchAllPractices()
   }

   fetchAllPractices(): void {
      this.growthToolkitClient.getAvailablePractices(null).subscribe((data) => {
         this.allPractices = data.filter((practice) => !practice.practiceName?.startsWith('(CLOSED'))
      })
   }
}
